export function replaceVariables(message: string, variables?: string[]): string {
	if (!variables) return message;
	let formatted = message;
	variables.forEach((v, i) => {
		formatted = formatted.replace(new RegExp(`\\{${i}\\}`, 'g'), v);
	});
	return formatted;
}

export function splitBoldParts(formatted: string): Array<{text: string; bold: boolean}> {
	const parts = formatted.split('**');
	// Remove empty string at start/end if present
	const mapped = parts.map((text, idx) => ({text, bold: idx % 2 === 1}));
	// Remove empty at start
	if (mapped.length && mapped[0].text === '') mapped.shift();
	// Remove empty at end
	if (mapped.length && mapped[mapped.length - 1].text === '') mapped.pop();
	return mapped;
}
